import React from 'react'
import { useTranslation } from 'react-i18next'

import { AmplitudeProvider } from '~/components/providers/AmplitudeEventProvider'

import { useBrandSeries } from '../../hooks/useBrandSeries'
import {
  eventNameSuffixMap,
  type Indicator,
  indicatorLabelI18nKeyMap,
  isPercentageOnlyIndicator,
} from '../../utils'

import { HeadingContainer } from './HeadingContainer'
import { TimeSeriesContent } from './TimeSeriesContent'

export type IndicatorContentProps = {
  indicator: Indicator
}
export const IndicatorContent = ({ indicator }: IndicatorContentProps) => {
  const { t } = useTranslation()

  const eventNameSuffix =
    eventNameSuffixMap[indicator as keyof typeof eventNameSuffixMap]

  const isPercentageOnly = isPercentageOnlyIndicator(indicator)

  const series = useBrandSeries(indicator)

  return (
    <AmplitudeProvider eventNameSuffix={eventNameSuffix}>
      <HeadingContainer
        indicator={indicator}
        isPercentageOnly={isPercentageOnly}
        label={t(indicatorLabelI18nKeyMap[indicator])}
      >
        <TimeSeriesContent
          isPercentageOnly={isPercentageOnly}
          series={series}
        />
      </HeadingContainer>
    </AmplitudeProvider>
  )
}
